import React from 'react';

const MAX_WIDTH = 520;
const MIN_WIDTH = 140;

function conversionColor(rate) {
  if (rate >= 60) return '#52c41a';
  if (rate >= 30) return '#faad14';
  return 'rgba(255,77,79,0.85)';
}

// eslint-disable-next-line no-unused-vars -- referenced by the commented-out avg/med time markup below
function formatDuration(seconds) {
  if (seconds == null) return '—';
  const days = seconds / 86400;
  if (days < 1) return `${(days * 24).toFixed(1)}h`;
  return `${days.toFixed(1)}d`;
}

function Dot() {
  return <span style={{ color: 'var(--border-color)' }}>·</span>;
}

export default function LifecycleFunnel({ stages, metrics }) {
  if (!stages || stages.length === 0) {
    return (
      <p style={{ color: 'var(--text-muted)', fontStyle: 'italic', fontSize: 13 }}>
        No stages configured.
      </p>
    );
  }

  const sorted = [...stages].sort((a, b) => a.order - b.order);
  const funnels = metrics?.funnels || {};
  const firstKey = sorted[0]?.key;
  const firstCount = funnels[firstKey]?.count ?? 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
      {sorted.map((stage, index) => {
        const funnel = funnels[stage.key];
        if (!funnel) return null;
        const count = funnel.count ?? 0;
        const cumulativePct = firstCount > 0 ? count / firstCount : (index === 0 ? 1 : 0);
        const widthPct = Math.max(cumulativePct, index === 0 ? 1 : MIN_WIDTH / MAX_WIDTH);
        const widthPx = Math.max(Math.round(MAX_WIDTH * widthPct), MIN_WIDTH);

        const nextStage = sorted[index + 1];
        const nextFunnel = nextStage ? funnels[nextStage.key] : null;
        const hasConversionData = nextFunnel && nextFunnel.conversion_rate != null;

        return (
          <React.Fragment key={stage.key}>
            <div style={{
              background: 'rgba(22,119,255,0.12)',
              border: '1px solid rgba(22,119,255,0.25)',
              borderRadius: 8,
              padding: '14px 20px',
              width: widthPx,
              maxWidth: MAX_WIDTH,
              textAlign: 'center',
            }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-primary)' }}>
                {stage.label}
              </div>
              <div style={{ fontSize: 26, fontWeight: 700, color: 'var(--text-primary)', margin: '4px 0' }}>
                {count.toLocaleString()}
              </div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                {funnel.total_rate != null ? `${funnel.total_rate}% of total` : (index === 0 && firstCount > 0 ? '100% of total' : '—')}
              </div>
            </div>

            {index < sorted.length - 1 && hasConversionData && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '6px 0',
              }}>
                <div style={{ width: 1, height: 8, background: 'var(--border-color)' }} />
                <div style={{
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-color)',
                  borderRadius: 12,
                  padding: '4px 14px',
                  fontSize: 11,
                  display: 'flex',
                  gap: 10,
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                }}>
                  <span style={{ color: conversionColor(nextFunnel.conversion_rate), fontWeight: 500 }}>
                    conversion {nextFunnel.conversion_rate}%
                  </span>
                  {nextFunnel.cumulative_rate != null && nextFunnel.cumulative_rate !== nextFunnel.conversion_rate && (
                    <>
                      <Dot />
                      <span style={{ color: 'var(--text-muted)' }}>
                        cumulative {nextFunnel.cumulative_rate}%
                      </span>
                    </>
                  )}
                  {/*<Dot />
                  <span style={{ color: 'var(--text-muted)' }}>
                    avg {formatDuration(nextFunnel.avg_time_seconds)}
                  </span>
                  <Dot />
                  <span style={{ color: 'var(--text-muted)' }}>
                    med {formatDuration(nextFunnel.median_time_seconds)}
                  </span>
                  <Dot />*/}
                  {/*<span style={{ color: '#ff4d4f' }}>
                    {(nextFunnel.drop_off ?? 0).toLocaleString()} dropped
                  </span>
                  {(nextFunnel.skipped_into ?? 0) > 0 && (
                    <>
                      <Dot />
                      <span style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>
                        +{nextFunnel.skipped_into} skipped in
                      </span>
                    </>
                  )}*/}
                </div>
                <div style={{ width: 1, height: 8, background: 'var(--border-color)' }} />
              </div>
            )}

            {index < sorted.length - 1 && !hasConversionData && (
              <div style={{ width: 1, height: 16, background: 'var(--border-color)' }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
